import React from 'react'
import { Flex, Text } from '@chakra-ui/core'
import { X } from 'lucide-react'
import { NoFocusButton } from 'components/CommonComponents/NoFocusButton'

interface ModalHeaderProps {
  title: string
  onClose: () => void
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ title, onClose }) => {
  return (
    <Flex justifyContent="space-between" alignItems="center" py={{ base: '5px', md: '10px' }}>
      <Text fontSize={{ base: '12px', md: '14px' }} fontWeight="bold">
        {title}
      </Text>
      <NoFocusButton px="0px" borderRadius="full" minWidth="unset" height="unset" minHeight="unset" onClick={onClose}>
        <X />
      </NoFocusButton>
    </Flex>
  )
}
